export default "__VITE_ASSET__24131b1a__"